module.exports = __webpack_public_path__ + "img/8.81e4e00e.png";